module.exports = __webpack_public_path__ + "img/button@2x.7190f100.png";